import React, { Fragment, useEffect, useRef, useState } from "react";
/// Data
import Pagination from '@mui/material/Pagination';
import axios from "axios";
import { Badge, Button } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import swal from 'sweetalert';
import { BACKEND_SERVER_URL } from "../../../http/http-config";
import ProdutsDetailsTabsAtTop from "../Common-Components/ProdutsDetailsTabsAtTop";
import SearchBox from "../Common-Components/SearchBox";
import '../common-css/Table.css';
import { bulkOperations, deleteItem, handleChecked, handleCheckedAll, showTableResponse } from "../common-helpers/commonServices";
import { getExamTypes } from "./CourseHelper";
import CourseModal from "./CourseModal";

const CourseGrid = () => {
    const childRef = useRef();
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [checked, setChecked] = useState(courses);
    const [unchecked, setUnChecked] = useState(true);
    const [loadCourses, setCourseLoading] = useState(false);
    const [selectedCourses, setSelectedCourses] = useState(courses);
    const [examWiseSelectedCourses, setExamWiseSelectedCourses] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedExamType, setExamType] = useState('Exam wise selection')
    const [selectedSubjectType, setSubjectType] = useState('Course Type wise selection')
    const [uniqueExamBodies, setUniqueExamBodies] = useState([]);
    const [courseTypes, setCourseTypes] = useState([]);
    const [uniqueSubjects, setUniqueSubjects] = useState([]);
    const [totalActiveCourses, setTotalActiveCourses] = useState([]);
    const [totalInactiveCourses, setTotalInactiveCourses] = useState([]);
    const [totalArchivedCourses, setTotalUnlisedCourses] = useState([]);

    // search functionality
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        const filteredCourses = courses?.filter(
            item => item?.courseTitle?.toLowerCase().includes(searchTerm?.toLowerCase())/* ||
            item?.titleHeading?.toLowerCase().includes(searchTerm?.toLowerCase()) */
        );
        setSelectedCourses(filteredCourses)
    }, [searchTerm])
    const handleSearch = (e) => {
        setSearchTerm(e.target.value)
    }

    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/getCourses').then((res) => {
            if (res.data) {
                let coursesData = res.data.courses;
                setCourses(coursesData)

                // apply previos filters line 58 to 77
                const courseFilters = JSON.parse(localStorage.getItem('courseFilters'));
                if (courseFilters) {
                    let examWiseCourses = [];
                    if (courseFilters.examType && courseFilters.examType != 'Exam wise selection' && courseFilters.examType != 'All Exams') {
                        setExamType(courseFilters.examType)
                        examWiseCourses = coursesData.filter((course) => course.examBody == courseFilters.examType)
                        setSelectedCourses(examWiseCourses)
                        setUniqueSubjects([...new Set(coursesData.filter(course => course.examBody == courseFilters.examType).map(course => course.type))]);
                    } else {
                        setSelectedCourses(coursesData)
                    }
                    if (courseFilters.courseType && courseFilters.courseType != 'Course Type wise selection') {
                        setSubjectType(courseFilters.courseType)
                        let subjectWiseSelectedCourses = examWiseCourses.filter((course) => course.type == courseFilters.courseType)
                        setSelectedCourses(subjectWiseSelectedCourses)
                    }
                } else {
                    setSelectedCourses(coursesData)
                }

                setTotalActiveCourses(coursesData.filter(course => course.status == 1 /* && course.type !== 'Unlised' */))
                setTotalInactiveCourses(coursesData.filter(course => course.status == 0/*  && course.type !== 'Unlised' */))
                let archivedYears = coursesData.filter(course => course.type == 'Unlised')
                setTotalUnlisedCourses(archivedYears)
            }
        }).catch((error) => {
            toast.error(error.response.data.message)
            console.log(error)
        })
        getExamTypes().then(examTypes => {
            let uniqueExamTypes = [...new Set(examTypes.map(course => course.exambody))]
            uniqueExamTypes.unshift("All Exams")
            setUniqueExamBodies(uniqueExamTypes)
        })
        // getTypes().then(types => {
        //     setCourseTypes(types)
        // })
        // return () => {
        //     localStorage.removeItem('courseFilters');
        // }
    }, [loadCourses])




    const pageSize = 50;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = selectedCourses.slice(firstIndex, lastIndex);

    const npage = Math.ceil(selectedCourses.length / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)

    function splitCamelCase(word) {
        return word?.replace(/([a-z])([A-Z])/g, '$1-$2')
            .split('-')
            .map(part => part.charAt(0).toUpperCase() + part.slice(1))
            .join(' ');
    }
    const selectExamHandler = (value) => {
        setExamType(value)
        localStorage.setItem('courseFilters', JSON.stringify({ examType: value, courseType: 'Course Type wise selection' }))
        setSubjectType('Course Type wise selection')
        if (value == "All Exams") {
            setExamWiseSelectedCourses(courses)
            setSelectedCourses(courses)
            setUniqueSubjects([]);
            return;
        }

        let examWiseSelectedCourses = courses.filter((course) => course.examBody == value)
        setExamWiseSelectedCourses(examWiseSelectedCourses)
        setSelectedCourses(examWiseSelectedCourses)
        setUniqueSubjects([...new Set(courses.filter(course => course.examBody == value).map(course => course.type))]);

    }

    const selectCourseTypeHandler = (value) => {
        setSubjectType(value)
        localStorage.setItem('courseFilters', JSON.stringify({ ...JSON.parse(localStorage.getItem('courseFilters')), courseType: value }))
        let subjectWiseSelectedCourses = examWiseSelectedCourses.filter((course) => course.type == value)
        setSelectedCourses(subjectWiseSelectedCourses)
    }
    const handleShowAllCourses = () => {
        setSelectedCourses(courses)
        setExamType('Exam wise selection');
        setSubjectType('Course Type wise selection');
        setUniqueSubjects([])
    }


    const handleUnlisedCourse = (CourseID) => {
        swal({
            title: "Are you sure?",
            text:
                "Once deleted, you will not be able to recover this course",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                axios.put(BACKEND_SERVER_URL + `/unlisedCourse/${CourseID}`).then(response => {
                    if (response.data.statusCode == 200) {
                        toast.success(response.data.message)
                        setCourseLoading(!loadCourses)
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }
        })
    }

    const resetFilters = () => {
        setExamType('Exam wise selection');
        setSubjectType('Course Type wise selection');
        setUniqueSubjects([]);
        localStorage.removeItem('courseFilters');
        setSelectedCourses(courses);
    }

    return (
        <Fragment>
            <div className="col-xl-12">
                <div className=" page-title p-2 mb-2">
                    <div className=' col-8 d-flex justify-content-between'>
                        <div className="col-3">
                            <button type="button" className="btn btn-dark btn-sm "
                                onClick={() => { resetFilters(); childRef.current.openModal() }}
                            >
                                + Add Course
                            </button>
                            {/* <button type="button" className="btn btn-success  btn-xs " onClick={() => childRef.current?.openModal()}> + Add Course</button> */}
                        </div>
                        <div className="col-4">
                            <div className="basic-dropdown">
                                <Select
                                    value={{ value: selectedExamType, label: selectedExamType }}
                                    onChange={(selectedOption) => selectExamHandler(selectedOption.value)}
                                    options={uniqueExamBodies.map((examBody) => ({ value: examBody, label: splitCamelCase(examBody) }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            backgroundColor: 'transparent', // Adjust as needed
                                            borderColor: '#17a2b8', // Adjust as needed

                                        }),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="basic-dropdown ms-3">
                                <Select
                                    value={{ value: selectedSubjectType, label: splitCamelCase(selectedSubjectType) }}
                                    onChange={(selectedOption) => selectCourseTypeHandler(selectedOption.value)}
                                    options={uniqueSubjects?.map((subject) => ({ value: subject, label: splitCamelCase(subject) }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            backgroundColor: 'transparent', // Adjust as needed
                                            borderColor: '#17a2b8', // Adjust as needed
                                        }),
                                    }}
                                />
                            </div>
                        </div>
                        {/* <div className="col-2">
                            <button type="button" className="btn btn-dark btn-xs ms-2 btn-block " onClick={handleShowAllCourses}> show All</button>
                        </div> */}
                    </div>
                    <div className=" col-4 input-group search-area mb-md-0 mb-3 w-25 " >

                        <SearchBox setChecked={setSelectedCourses} dataArray={courses} searchingProperty={'courseTitle'} />
                    </div>
                </div>
                <ProdutsDetailsTabsAtTop moduleType='course' setChecked={setSelectedCourses} totalItems={courses} totalActiveItems={totalActiveCourses} totalInactiveItems={totalInactiveCourses} totalArchivedItems={totalArchivedCourses} />
            </div>
            <div className="dataTables_wrapper no-footer">
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <div>
                        <Button variant="danger ms-3" size='xs' onClick={(e) => bulkOperations("delete", records, '/unlisedCourses', 'Courses', setCourseLoading, loadCourses)}>Delete</Button>
                        <Button variant="success ms-3 " size='xs' onClick={(e) => bulkOperations("activate", records, '/activateCourses', 'Courses', setCourseLoading, loadCourses)}>Active</Button>
                        <Button variant="warning ms-3" size='xs' onClick={(e) => bulkOperations("InActivate", records, '/inactivateCourses', 'Courses', setCourseLoading, loadCourses)}>Inactive</Button>
                    </div>
                    <div className='dataTables_info text-dark'>
                        Records: {selectedCourses.length}
                    </div>
                    {selectedCourses.length > pageSize ? <div className="">
                        <div className=""
                            id="example-student_wrapper">
                            <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                        </div>
                    </div> : null
                    }
                </div>
            </div>

            <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)', transform: 'rotateX(180deg)' }}>
                    <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                        <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student">
                            <thead style={{ backgroundColor: "#cccccc" }} className="custom-table-header">
                                <tr className='text-center  border border-left '>
                                    <th className=' custom-table-header  p-2 '>Order No.</th>
                                    <th className=' custom-table-header  p-2'>
                                        <input type="checkbox" className="form-check-input" id="checkAll"
                                            /*   checked={!unchecked} */
                                            onClick={() => handleCheckedAll(unchecked, selectedCourses, setSelectedCourses, setUnChecked)}
                                        />
                                    </th>
                                    <th className='p-2 text-start  custom-table-header '>STATUS</th>
                                    <th className=' text-start custom-table-header  p-2' >COURSE TITLE</th>
                                    <th className=' text-start custom-table-header  p-2' >TITLE HEADING</th>
                                    <th className=' text-start custom-table-header  p-2' >EXAM BODY</th>
                                    <th className=' text-start custom-table-header  p-2' >TYPE</th>
                                    <th className='p-2 custom-table-header '>LESSONS</th>
                                    <th className='p-2 custom-table-header '>SUBSCRIBERS</th>

                                </tr>
                            </thead>
                            <tbody>
                                {records.length > 0 ? records.map((item, ind) => (
                                    <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                        <td className='text-center p-1 column-width' style={{ border: "1px solid #cccccc", width: "65px" }} ><h6 className="sn-font-weight mb-0"> {item.orderNo}</h6></td>
                                        <td className='text-center p-1 column-width' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                            <div className="checkbox me-0 align-self-center">
                                                <div className="custom-control custom-checkbox ">
                                                    <input type="checkbox"
                                                        className="form-check-input"
                                                        id={`stud-${item.sn}`}
                                                        checked={item.inputchecked}
                                                        onChange={() => handleChecked(item.sn, setSelectedCourses, selectedCourses)}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`stud-${item.sn}`}></label>
                                                </div>
                                            </div>
                                        </td>
                                        <td className='text-start p-1 active-col-width' style={{ border: "1px solid #cccccc", width: "80px" }}>
                                            {item.status === 1 && <h6 className="text-success mb-0 ">Active </h6>}
                                            {item.status === 0 && <h6 className="text-danger mb-0">Inactive </h6>}
                                        </td>
                                        <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                            <div className="d-flex justify-content-between ">
                                                <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>
                                                    {item.courseTitle}{' '}
                                                                                                        {/* <CiEdit cursor='pointer' title='Edit Course' size={18} className='ms-3' onClick={() => { resetFilters(); childRef.current.openModal(item.courseId) }} /> */}
                                                    <CiEdit cursor='pointer' title='Edit Course' size={18} className='ms-3' onClick={() => { childRef.current.openModal(item.courseId) }} />
                                                    <MdDeleteOutline color='red' title='Delete Course' cursor='pointer' size={18} className='ms-2' onClick={() => { deleteItem(item.courseId, 'Course', '/unlisedCourse/', setCourseLoading, loadCourses) }}
                                                    />
                                                </h6>
                                            </div>
                                        </td>
                                        <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                            <div className="d-flex justify-content-between ">
                                                <h6 className='mb-0 '>{item.titleHeading}{' '}

                                                </h6>
                                            </div>
                                        </td>
                                        <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                            <div className="d-flex justify-content-between ">
                                                <h6 className='mb-0 '>{item.examBody}{' '}

                                                </h6>
                                            </div>
                                        </td>
                                        <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                            <div className="d-flex justify-content-between ">
                                                <h6 className='mb-0 '>{item.type}{' '}

                                                </h6>
                                            </div>
                                        </td>
                                        <td className='p-1 text-center active-col-width' style={{ border: "1px solid #cccccc", width: '80px' }}><h6 className="mb-0 ">{item.topicCount || 0}</h6></td>
                                        <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                            <h6 className="mb-0 cursor-pointer" onClick={() => navigate('/subscribers', { state: { courseId: item.courseId } })}>
                                                <Badge bg="" className='badge-primary light badge-sm ms-2 cursor-pointer pe-3 ps-3' >    {item.preSubscribers || 0}   +  {item.realSubscribers}</Badge>


                                            </h6>
                                        </td>
                                        {/*  <td className='text-start p-1' style={{ border: "1px solid #cccccc" }}>
                                    <h6 className="mb-0" style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.courseTitle}</h6>
                                </td>
                                <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "65px" }}><h6 className="mb-0">{new Date(item?.startDate?.replace(/\s+/g, ""))?.toLocaleDateString('en-GB')}</h6></td>
                                <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "65px" }}><h6 className="mb-0">{new Date(item?.adminCloseDate?.replace(/\s+/g, ""))?.toLocaleDateString('en-GB')}</h6></td> */}

                                    </tr>
                                )) :
                                    <tr>
                                        <td colSpan="9" className="text-center">
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                {
                                                    showTableResponse(courses, selectedCourses)
                                                }
                                            </div>
                                        </td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <CourseModal ref={childRef} loadCourses={loadCourses} setCourseLoading={setCourseLoading} />
        </Fragment>
    );
};

export default CourseGrid;



